import styled from 'styled-components';

export const BottomSheetSelectContent = styled.div`
  padding-bottom: 20px;
`;
